import { render, staticRenderFns } from "./UploadIdPhoto.vue?vue&type=template&id=17ec8792&scoped=true"
import script from "./UploadIdPhoto.vue?vue&type=script&lang=js"
export * from "./UploadIdPhoto.vue?vue&type=script&lang=js"
import style0 from "./UploadIdPhoto.vue?vue&type=style&index=0&id=17ec8792&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ec8792",
  null
  
)

export default component.exports